{
  "commandCenter": {
    "title": "Command center",
    "description": "Type a command — a canvas name to switch to it.",
    "inputLabel": "Command",
    "placeholder": "Go to a canvas…",
    "listLabel": "Commands",
    "empty": "No command",
    "noMatch": "No match for “{{query}}”.",
    "current": "Current",
    "groups": {
      "bookmarks": "Bookmarks",
      "canvases": "Canvases",
      "sharedCanvases": "Shared with me"
    },
    "footer": {
      "navigate": "navigate",
      "run": "run",
      "close": "close"
    }
  },
  "sidebar": {
    "title": "Sidebar",
    "description": "Displays the mobile sidebar.",
    "toggle": "Toggle sidebar"
  },
  "blocknote": {
    "loadingEditor": "Loading editor",
    "documentTooLarge": "This document is too large: new changes won't be saved until it's shortened.",
    "renderError": "Unable to display this content."
  },
  "corruptedDocument": {
    "title": "This document couldn't be loaded",
    "description": "Its content is corrupted and couldn't be displayed. It can still be recovered from the server until you confirm, but continuing will permanently delete it.",
    "continue": "Continue (delete corrupted content)"
  },
  "upload": {
    "failed": "File upload failed",
    "failedWithStatus": "Upload failed ({{status}})"
  },
  "datePill": {
    "pick": "Pick a date",
    "today": "Today",
    "yesterday": "Yesterday",
    "tomorrow": "Tomorrow"
  },
  "slashMenu": {
    "date": {
      "title": "Date",
      "subtext": "Insert a date pill"
    },
    "pill": {
      "title": "Pill",
      "subtext": "Insert a colored pill"
    },
    "callout": {
      "title": "Callout",
      "subtext": "Insert a colored callout with an icon"
    }
  },
  "callout": {
    "title": "Title",
    "levelText": "Text",
    "color": "Color",
    "defaultColor": "Default"
  },
  "pill": {
    "variants": {
      "pastel": "Pastel",
      "solid": "Solid"
    }
  },
  "mention": {
    "notFound": "Node not found",
    "tooltip": "{{label}} — click to go to, {{modifier}}+click to open"
  },
  "noleComment": {
    "label": "Comment for Nolë",
    "tooltip": "Adds the passage and your comment to the chat",
    "button": "Comment"
  },
  "nodeTypes": {
    "link": "Links",
    "image": "Images",
    "blocknote": "Notes",
    "value": "Values",
    "title": "Titles",
    "file": "Files",
    "table": "Tables",
    "app": "Apps",
    "audio": "Audio",
    "video": "Videos",
    "frame": "Frames",
    "board": "Boards",
    "custom": "Custom",
    "database": "Databases",
    "databaseView": "Database views"
  },
  "relativeTime": {
    "justNow": "just now",
    "minutes": "{{value}}m",
    "hours": "{{value}}h",
    "days": "{{value}}d"
  },
  "search": {
    "placeholder": {
      "titles": "Search titles — \"phrase\", -exclude, a OR b",
      "semantic": "Semantic search — describe the idea",
      "keyword": "Search — \"phrase\", -exclude, a OR b"
    },
    "clear": "Clear search",
    "titlesOnly": "Titles only",
    "noResults": "No results",
    "noNodes": "No nodes yet",
    "recent": "Recent",
    "relaxed": "No exact results — showing close matches.",
    "resultCount_one": "{{count}} result",
    "resultCount_other": "{{count}} results",
    "untitledRow": "Untitled row",
    "untitledFrame": "Frame",
    "page": "Page {{page}}",
    "previewAlt": "Preview",
    "error": "An error occurred.",
    "errorWithMessage": "An error occurred: {{message}}.",
    "semanticUnavailable": "Semantic search is unavailable right now — keyword mode still works.",
    "degraded": "Semantic search unavailable — showing keyword results only.",
    "typeFilter": {
      "label": "Filter by node type",
      "showAll": "Show all"
    },
    "typeDropdown": {
      "trigger": "Type",
      "triggerWithTypes": "Type: {{types}}",
      "remove": "Remove {{type}}",
      "placeholder": "Filter by type…",
      "inputLabel": "Filter node types",
      "clear": "Clear types",
      "listLabel": "Node types",
      "empty": "No matching type"
    },
    "mode": {
      "label": "Search mode",
      "keyword": {
        "full": "Keyword",
        "short": "Key",
        "hint": "Keyword search"
      },
      "auto": {
        "full": "Auto",
        "short": "Auto",
        "hint": "Hybrid search"
      },
      "semantic": {
        "full": "Semantic",
        "short": "Sem",
        "hint": "Semantic search"
      }
    },
    "edited": {
      "trigger": "Edited",
      "triggerWithValue": "Edited: {{value}}",
      "any": "Any time",
      "today": "Today",
      "week": "Last 7 days",
      "month": "Last 30 days"
    },
    "sort": {
      "trigger": "Sort",
      "label": "Sort: {{value}}",
      "relevance": "Best match",
      "edited": "Last edited",
      "created": "Recently created"
    }
  },
  "mobile": {
    "canvasLoadError": "This canvas could not be loaded",
    "nav": {
      "label": "Main navigation",
      "canvas": "Canvas",
      "search": "Search",
      "chat": "Chat"
    },
    "workspaces": {
      "title": "Workspaces",
      "all": "All workspaces",
      "create": "New workspace",
      "empty": "No workspaces",
      "shared": "Shared with you",
      "fallbackName": "Workspace",
      "delete": "Delete workspace",
      "deleteConfirmTitle": "Delete workspace “{{name}}”?",
      "deleteConfirmText": "Its nodes and conversations go with it."
    },
    "threads": {
      "title": "Conversations",
      "newSession": "New session",
      "empty": "No conversations on this canvas",
      "delete": "Delete conversation"
    },
    "chat": {
      "newChat": "New chat",
      "history": "Conversation history",
      "dictationHint": "Hold the mic button and speak to dictate",
      "answerPlaceholder": "Type your answer to Nolë's question…",
      "dictationEngine": "Dictation engine",
      "holdToDictate": "Hold to dictate"
    },
    "toolbar": {
      "addBlock": "Add a block",
      "redo": "Redo"
    },
    "overlay": {
      "back": "Back to chat",
      "refresh": "Refresh",
      "moreOptions": "More options",
      "navigateToNode": "Navigate to node",
      "history": "History",
      "threads": "Threads that modified this node"
    }
  }
}
